import type { ServiceClientSearchQuery } from './types';

/**
 * Converts the list view query into the payload shape expected by the search API.
 * Maps the vehicle filter (TSelectItem[]) to service.vehicles._id (array of ids) so the
 * backend can filter by lead.service.vehicles[].vehicle._id.
 *
 * @param query - Output of buildSearchQuery (filters + 1-based page)
 * @returns Plain object suitable for POST /service-clients/search (vehicle → service.vehicles._id)
 */
export function buildSearchPayload(
    query: ServiceClientSearchQuery
): Record<string, unknown> {
    const payload: Record<string, unknown> = { ...query };
    if (query.vehicle && Array.isArray(query.vehicle) && query.vehicle.length > 0) {
        payload['service.vehicles.vehicle._id'] = query.vehicle.map((v) => ({ value: v.value, label: v.label }));
        delete payload.vehicle;
    }
    if (query.assigned && Array.isArray(query.assigned) && query.assigned.length > 0) {
        payload.agent = query.assigned.map((a) => a.value);
        delete payload.assigned;
    }
    if (query.createdAt && query.createdAt.gte && query.createdAt.lt) {
        payload.createdAt = {
            gte: query.createdAt.gte,
            lt: query.createdAt.lt,
        };
    }
    return payload;
}
